<template>
  <div>
    <keep-alive v-if="false" :key="$route.path">
      <router-view :key="$route.path"></router-view>
    </keep-alive>
    <router-view v-else :key="$route.path"></router-view>

    <van-tabbar v-model="active" v-show="hasShowTabbar" style="z-index: 3000;">
      <van-tabbar-item icon="home-o" replace to="/location/reserve/index">{{ $t('locationTabbar1') }}</van-tabbar-item>
      <van-tabbar-item icon="orders-o" replace to="/location/reserve/order/list">{{ $t('locationTabbar2') }}</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    hasShowTabbar() {
      const path = this.$route.path;
      return ['/location/reserve/index', '/location/reserve/order/list'].includes(path);
    }
  },
  created() {
    this.active = this.$route.path == '/location/reserve/index' ? 0 : 1
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped></style>